"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var table_dragula_options_1 = require("./table-dragula.options");
var draggable_column_model_1 = require("./draggable-column.model");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var Subject_1 = require("rxjs/Subject");
require("./sis-table-settings.component.scss");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var SisTableSettings = /** @class */ (function (_super) {
    __extends(SisTableSettings, _super);
    function SisTableSettings(kbService, communicationService, formService) {
        var _this = _super.call(this, communicationService) || this;
        _this.kbService = kbService;
        _this.communicationService = communicationService;
        _this.formService = formService;
        _this.fields = {};
        _this.subFieldModels = [];
        _this.tableDragulaOptions = new table_dragula_options_1.TableDragulaOptions();
        _this.metaFieldTypes = idm_kb_service_client_js_1.MetaFieldType;
        _this._state = {};
        _this._subEntityMetaFields = [];
        _this._subForms = [];
        _this.destroySubject$ = new Subject_1.Subject();
        return _this;
    }
    Object.defineProperty(SisTableSettings.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (state) {
            this._state = state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTableSettings.prototype, "selectedMetaField", {
        get: function () {
            return this._selectedMetaField;
        },
        set: function (value) {
            this._selectedMetaField = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTableSettings.prototype, "subEntityMetaFields", {
        get: function () {
            return this._subEntityMetaFields;
        },
        set: function (value) {
            this._subEntityMetaFields = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTableSettings.prototype, "isAddable", {
        get: function () {
            return this._isAddable;
        },
        set: function (value) {
            this._isAddable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTableSettings.prototype, "isDeletable", {
        get: function () {
            return this._isDeletable;
        },
        set: function (value) {
            this._isDeletable = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTableSettings.prototype, "selectedFormData", {
        get: function () {
            return this._selectedFormData;
        },
        set: function (value) {
            this._selectedFormData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTableSettings.prototype, "subForms", {
        get: function () {
            return this._subForms;
        },
        set: function (value) {
            this._subForms = value;
        },
        enumerable: true,
        configurable: true
    });
    SisTableSettings.prototype.ngOnInit = function () {
        var _this = this;
        this.kbService
            .getMetaFields(this.category)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (metaFields) {
            _this._subEntityMetaFields = metaFields.filter(function (metaField) {
                return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY;
            });
        }, console.error);
        this.prepareFields();
        this.prepareState();
    };
    SisTableSettings.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    SisTableSettings.prototype.categoryChange = function (selectedCategory) {
        var _this = this;
        if (selectedCategory) {
            var selectedMetaField = this._subEntityMetaFields.find(function (item) {
                return item.getCompoundCategorySystemName() === selectedCategory;
            });
            this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {},
                fields: {
                    field: selectedMetaField,
                },
            }));
            this.communicationService.peerSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, []));
            this.kbService
                .getMetaFields(selectedCategory)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (metaFields) {
                _this.subFieldModels = metaFields.map(function (field) { return new draggable_column_model_1.DraggableColumnModel(field); });
            }, console.error);
            this.formService
                .allSubFormsByCategoryAndType(this.category, selectedCategory, this.formType)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (data) {
                _this.subForms = data;
            }, console.error);
        }
    };
    SisTableSettings.prototype.subFormChange = function (formData) {
        if (formData) {
            this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                state: {
                    subFormKey: formData.model.formName,
                    formId: formData.id,
                },
            }));
        }
    };
    SisTableSettings.prototype.changeAddableProperties = function (value) {
        this.isAddable = value;
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            state: {
                isAddable: this.isAddable,
            },
        }));
    };
    SisTableSettings.prototype.changeDeletableProperties = function (value) {
        this.isDeletable = value;
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            state: {
                isDeletable: this.isDeletable,
            },
        }));
    };
    SisTableSettings.prototype.trackByFieldModelsIds = function (index, subFieldModel) {
        return subFieldModel.id;
    };
    SisTableSettings.prototype.trackByFormsIds = function (index, selectedFormData) {
        return selectedFormData.id;
    };
    SisTableSettings.prototype.isEditForm = function () {
        return this.formType === idm_dynamic_layout_interpreter_1.FormType.EDIT;
    };
    SisTableSettings.prototype.prepareFields = function () {
        var _this = this;
        if (this.fields.field) {
            this.selectedMetaField = this.fields.field;
            if (this.selectedMetaField) {
                var formId_1 = this._state['formId'];
                this.formService
                    .allSubFormsByCategoryAndType(this.category, this.selectedMetaField.getCompoundCategorySystemName(), this.formType)
                    .pipe(operators_1.takeUntil(this.destroySubject$))
                    .subscribe(function (data) {
                    _this.subForms = data;
                    if (formId_1) {
                        _this.selectedFormData = _this.subForms.find(function (sub) { return sub.id === formId_1; });
                    }
                }, console.error);
                this.kbService
                    .getMetaFields(this.selectedMetaField.getCompoundCategorySystemName())
                    .pipe(operators_1.takeUntil(this.destroySubject$))
                    .subscribe(function (metaFields) {
                    _this.subFieldModels = metaFields.map(function (field) { return new draggable_column_model_1.DraggableColumnModel(field); });
                }, console.error);
            }
        }
    };
    SisTableSettings.prototype.prepareState = function () {
        var _this = this;
        if (this._state) {
            this.isAddable = this._state['isAddable'];
            this.isDeletable = this._state['isDeletable'];
            if (this._state.colSystemNames) {
                this._state.colSystemNames.forEach(function (col) {
                    var sub = _this.subFieldModels.find(function (item) { return item.systemName === col; });
                    if (sub) {
                        sub.disabled = true;
                    }
                });
            }
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisTableSettings.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisTableSettings.prototype, "formType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisTableSettings.prototype, "fields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], SisTableSettings.prototype, "state", null);
    SisTableSettings = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-table-settings',
            template: require('./sis-table-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-table-settings [category]=\"%{category}\" [formType]=\"%{formType}\"\n                            [fields]=\"%{fields}\" [state]=\"%{state}\" [currentLanguageId]=\"%{currentLanguageId}\"\n                            [languages]=\"%{languages}\" [controlLabel]=\"%{controlLabel}\">\n                              </sis-table-settings>",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_dynamic_controls_metadata_1.CommunicationService,
            idm_dynamic_layout_interpreter_1.FormService])
    ], SisTableSettings);
    return SisTableSettings;
}(idm_ng_controls_1.BaseSettings));
exports.SisTableSettings = SisTableSettings;
//# sourceMappingURL=sis-table-settings.component.js.map